import React from 'react';
import { StyledSectionHead, IconContainer, SectionHeadWrapper } from "./styles";










export const SectionHead = ({ title, icon = null, classNames = {} }) => {
  return /*#__PURE__*/(
    React.createElement(SectionHeadWrapper, null,
    icon && /*#__PURE__*/React.createElement(IconContainer, { className: classNames.iconContainer }, icon), /*#__PURE__*/
    React.createElement(StyledSectionHead, { className: classNames.sectionHead }, title)));


};